import {
  doc,
  collection,
  getDocs,
  updateDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

// USER

export const updateUserFirebase = async (user) => {
  console.log("user updated");
  await updateDoc(doc(db, "users", user.id), {
    category: user.category ? user.category : "",
    member: user.member ? user.member : false,
    staff: user.staff ? user.staff : false,
    profilePic: user.profilePic ? user.profilePic : "",
    research: user.research ? user.research : "",
    sex: user.sex ? user.sex : "",
    birthDate: user.birthDate ? user.birthDate : "",
    age: user.age ? user.age : "",
    social: user.social ? user.social : "",
    education: user.education ? user.education : "",
    listProblems: user.listProblems ? user.listProblems : [],
    listGoals: user.listGoals ? user.listGoals : [],
    listValues: user.listValues ? user.listValues : "",
    actionPlan: user.actionPlan ? user.actionPlan : "",
    personalityTraits: user.personalityTraits ? user.personalityTraits : "",
    favorites: user.favorites ? user.favorites : "",
    wordCloud: user.wordCloud ? user.wordCloud : [],
    phrases: user.phrases ? user.phrases : [],
  });
};

// USERS

export const getUserByIdFirebase = async (id) => {
  const docRef = collection(db, "users");
  const q = query(docRef, where("id", "==", id));
  const querySnap = await getDocs(q);
  if (querySnap) {
    console.log(`user ${id} loaded`);
    return querySnap.docs.map((doc) => ({ ...doc.data() }));
  } else {
    console.log("No appointments document");
  }
};

export const getProfessionalsFirebase = async () => {
  const docRef = collection(db, "users");
  const q = query(
    docRef,
    where("clinic", "array-contains", "perspectiva"),
    where("category", "==", "doctor")
  );
  const querySnap = await getDocs(q);
  if (querySnap) {
    console.log(`perspectiva professionals loaded`);
    return querySnap.docs.map((doc) => ({ ...doc.data() }));
  } else {
    console.log("No appointments document");
  }
};
